import { isPlainObject } from '../../views/utils'

export default {
  auto: ['actions'],
  store: {
    state: {
      list: [],
    },
    actions: {
      ERROR({ commit, dispatch, getters }, err) {
        commit('ADD_ERROR', err)

        // report error to the server
        if (isPlainObject(err)) {
          dispatch('CREATE_ERRORS', {
            name: err.name,
            message: err.message.slice(0, 254),
            code: err.code,
            url: getters.url,
          })
        }

        // display error to user
        const message = (isPlainObject(err) && err.message)
          ? err.message
          : err

        return dispatch('DANGER', message)
      },
    },
    mutations: {
      ADD_ERROR(state, err) {
        state.list.push(err)
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/errors.js